
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table2";
import CadastroEmpresaCopiarButton from "@/modules/GrupoEmpresa/components/CadastroEmpresaCopiarButton.vue";
import { cadastroEmpresaCopiaMixin } from "@/modules/GrupoEmpresa/mixins/cadastroEmpresaCopia";

export default {
  name: "app-perfil-tributario",
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
    CadastroEmpresaCopiarButton,
  },
  mixins: [cadastroEmpresaCopiaMixin],
  data() {
    return {
      fields: [
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: false,
          width: "80%",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar pela descrição",
          },
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "20%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
    };
  },
  methods: {
    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o perfil tributário " + data.descricao + "?",
          text: "Você tem certeza que deseja excluir este perfil?",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.handleDelete(data);
          }
        });
    },
    async handleDelete(data) {
      try {
        const response = await this.$http.post("/perfil-tributario/delete", {
          id: data.id,
        });

        this.$toast.success(
          (response.data && response.data.message) ||
            "Perfil excluído com sucesso!"
        );
        this.$refs.perfilTributario.refresh();
        return;
      } catch (error) {
        console.error("Erro ao deletar perfil:", error);
        this.$refs.perfilTributario.refresh();
      }
    },
  },
};
